import React, { useState } from 'react';
import { Dictionary } from './Dictionary';
import { UnitConverter } from './UnitConverter';
import { Principles } from './Principles';

type Tool = 'dictionary' | 'converter' | 'principles';

const TABS: { id: Tool; label: string }[] = [
    { id: 'dictionary',  label: '📚 용어 사전' },
    { id: 'converter',   label: '🔄 단위 변환' },
    { id: 'principles',  label: '⚙️ 기기 원리' },
];

export const ToolsPage: React.FC = () => {
    const [activeTool, setActiveTool] = useState<Tool>('dictionary');

    return (
        <div>
            <div style={{
                display: 'flex',
                backgroundColor: '#f4f1ea',
                borderBottom: '2px solid #c4b8a5',
            }}>
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTool(tab.id)}
                        style={{
                            flex: 1,
                            padding: '13px 4px',
                            border: 'none',
                            backgroundColor: 'transparent',
                            fontSize: '12px',
                            fontWeight: activeTool === tab.id ? 700 : 400,
                            color: activeTool === tab.id ? '#1e3a5f' : '#5a5a5a',
                            borderBottom: activeTool === tab.id ? '3px solid #c75c2e' : '3px solid transparent',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {activeTool === 'dictionary' && <Dictionary />}
            {activeTool === 'converter' && <UnitConverter />}
            {activeTool === 'principles' && <Principles />}
        </div>
    );
};
